import Button, {
  ButtonIconPosition,
  ButtonSize,
  ButtonVariant,
} from '@/components/BaseLibrary/Button/Button';
import { IconName } from '@/components/Icon/Icon';
import ResponsiveImage from '@/components/Image/ResponsiveImage';
import VideoPlayer from '@/components/VideoPlayer/VideoPlayer';
import type {
  FrontifyImageContent,
  LinkContent,
} from '@/contentful/contentful-exports';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './BlogHero.styles';

interface BlogHeroContent {
  title: string;
  subtitle?: string;
  image: [FrontifyImageContent];
  video?: string;
  imageAltText?: string;
  backButton?: LinkContent;
}

export default function BlogHero({
  title,
  subtitle,
  image,
  video,
  imageAltText,
  backButton,
}: BlogHeroContent): React.JSX.Element {
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  return (
    <div className={classes.blogHero}>
      {backButton && (
        <Button
          label={backButton.fields.text}
          href={backButton.fields.url}
          iconName={IconName.ARROW_LEFT}
          iconPosition={ButtonIconPosition.LEFT}
          variant={ButtonVariant.TERTIARY}
          size={ButtonSize.SM}
        />
      )}
      <h1 className={globalClasses.h2}>{title}</h1>
      {subtitle && (
        <p className={cx(globalClasses.bodyLg, classes.subtitle)}>{subtitle}</p>
      )}
      {video ? (
        <VideoPlayer
          url={video}
          controls
          className={classes.videoPlayer}
          width='100%'
          height='auto'
        />
      ) : (
        image?.[0] && (
          <ResponsiveImage
            sizes={{ xs: 592, sm: 944, lg: 1280 }}
            priority
            src={image[0]}
            alt={imageAltText || ''}
            className={classes.image}
          />
        )
      )}
    </div>
  );
}
